<template>
  <div>
    <div class="row" v-if="labelPosition === 'left'">
      <div class="col-md-4">
        <label
          class="form-control-label"
          :class="{'bold': control.labelBold, 'italic': control.labelItalic, 'underline': control.labelUnderline}"
        >{{control.label}}</label>
      </div>
      <div class="col-md-8">
        <div>
          <qrcode-stream @decode="decode" />
        </div>
        <div>
          <b-form-input
            v-model="value"
          />
        </div>
      </div>
    </div>
    <div v-else>
      <label
        class="form-control-label"
        :class="{'bold': control.labelBold, 'italic': control.labelItalic, 'underline': control.labelUnderline}"
      >{{control.label}}</label>
    </div>
  </div>
</template>

<script>
import { requiredIf } from 'vuelidate/lib/validators'
import { Hooks } from '@/components/DataGrid/FormBuilder/gui/components/hook_lists'

export default {
  name: 'TextControl',
  props: ['control', 'labelPosition'],
  data() {
    return {
      value: this.control.value,
    }
  },
  watch: {
    'control.value'() {
      this.value = this.control.value
    },
  },
  methods: {
    decode(value) {
      this.value = value
      this.control.value = value

      const fbInst = this.$instByClass(this, 'form-builder-root')

      fbInst.setRowDataVal(this.control.propName, value)
    },
  },
}
</script>
